export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/hero/stem-background.png"
          alt="Ahmad Danial portfolio background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-stem-dark/30" />
      </div>
    </section>
  );
}
